import AppCatalog from "../../../services/App/AppCatalog.js";
import Catalog from "../VenCatalog.js";
import VendorAddressCatalog from "../VenaCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: AppCatalog.Field.Search.Label + " " +
      Catalog.Name.Label + ", atau " +
      Catalog.Alias.Label + ", atau " +
      VendorAddressCatalog.Address.Label + ", atau " +
      VendorAddressCatalog.ContactMobile.Label + ", atau " +
      VendorAddressCatalog.ContactPhone.Label + ", atau " +
      VendorAddressCatalog.ContactEmail.Label,
    Type: AppCatalog.Field.Search.Type,
    MaxLength: AppCatalog.Field.Search.MaxLength
  }
}